import type { Mission } from '../missions.ts'

export const uspto: Mission = {
  id: "uspto",
  name: "United States Patent and Trademark Office",
  short: "USPTO",
  call: "Innovation",
  kind: "subagency",
  parent: "doc",
  url: "https://www.uspto.gov/",
  established: 1790,
  palette: {
    primary: "#004c97",
    secondary: "#162e51",
    accent: "#f2a900",
  },
  colorSource: {
    kind: "site",
    url: "https://www.uspto.gov/",
  },
  motif: "bulb",
  mission: {
    text: "Our mission is to drive U.S. innovation and global competitiveness for the benefit of all Americans.",
    url: "https://www.uspto.gov/about-us",
  },
  fact: {
    text: "The first U.S. patent, granted in 1790, went to Samuel Hopkins for a process of making potash.",
    url: "https://www.uspto.gov/patents/milestones",
  },
  seal: {
    file: "public/seals/uspto.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Patent_and_Trademark_Office.svg",
  },
  identifier: {
    about: "https://www.uspto.gov/about-us",
    accessibility: "https://www.uspto.gov/using-usptogov/accessibility-uspto-website",
    foia: "https://www.uspto.gov/learning-and-resources/ip-policy/electronic-freedom-information-act-e-foia",
    noFear: "https://www.uspto.gov/about-us/nofear-act",
    oig: "https://www.oig.doc.gov/about/oversight-areas/u-s-patent-and-trademark-office-pto/",
    performance: "https://www.uspto.gov/about-us/financial-and-performance",
    privacy: "https://www.uspto.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/uspto-patent-office-building.jpg",
        small: "/media/uspto-patent-office-building-sm.jpg",
        alt: "The Greek Revival Patent Office Building in Washington, D.C., with its columned portico, seen across an open lot.",
        title: "Patent Office Building, Washington, D.C. (Historic American Buildings Survey)",
        creator: "Jack E. Boucher, Historic American Buildings Survey, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:General_view_-_Patent_Office_Building,_Bounded_by_Seventh,_Ninth,_F_and_G_Streets,_Northwest,_Washington,_District_of_Columbia,_DC_HABS_DC,WASH,503-66.tif",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/uspto-patent-office-1880.jpg",
        small: "/media/uspto-patent-office-1880-sm.jpg",
        alt: "An engraved vignette of the U.S. Patent Office building with carriages and pedestrians in front, from an 1880s patent certificate.",
        title: "U.S. Patent Office, engraving from an 1880s patent certificate",
        creator: "U.S. Patent Office",
        source: "https://commons.wikimedia.org/wiki/File:United_States_Patent_Office_c1880.jpg",
        license: "Public domain (published before 1931)",
      },
    ],
  },
}
